/**
 * Story 20.3 (AMA-333) — shared `UUID_REGEX` extracted from
 * `useChatUrlState.ts:52` so the citation-link parser in
 * `MessageBody.tsx` validates UUIDs against the same literal as the
 * URL-state hook. Avoids the "two regex literals drift" hazard.
 *
 * RFC-4122 UUID v1-v5 (hyphenated, case-insensitive). Matches Story 18.11
 * URL-state acceptance set.
 */

export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUuid(value: string | null): value is string {
  return typeof value === 'string' && UUID_REGEX.test(value);
}
